import { firebase } from './firebaseConfig';
import Fuse from 'fuse.js';
const db = firebase.firestore();

// ======================== Get posts data ========================

function formatPostsData(postID, authorName, date, summary, sector, city, region, country, upvotes, authorID, description, features, upvoters) {
  return {  postID, authorName, date, summary, sector, city, region, country, upvotes, authorID, description, features, upvoters };
}

export async function getPosts ({setState, search, sector, startDate, setLoading, lastPost, setLastPost, existingPosts, setNoMore}) {
  try {
    if (setLoading) setLoading(true);
    if (startDate) startDate = firebase.firestore.Timestamp.fromDate(startDate);
    let postsData = []; let snapshot = []; let firebaseQuery, newLastPost;

    //No filters
    if (!search && !sector && !startDate) firebaseQuery = db.collection('posts').where('date', '<', firebase.firestore.Timestamp.fromDate(new Date()) ).orderBy('date', 'desc').limit(25);
    //Just search - pt. 1
    else if (search && !sector && !startDate) firebaseQuery = db.collection('posts').orderBy('date', "desc").where('date', '<', firebase.firestore.Timestamp.fromDate(new Date()) ).limit(250);
    //Just sectors
    else if (!search && sector && !startDate) firebaseQuery = db.collection('posts').orderBy('date', 'desc').where('sector', 'array-contains-any', sector).limit(25);
    //Just date
    else if (!search && !sector && startDate) firebaseQuery = db.collection('posts').where('date', '>=', startDate).orderBy('date', 'desc').limit(25);
    //Search + sectors - pt. 1
    else if (search && sector && !startDate) firebaseQuery = db.collection('posts').orderBy('date', 'desc').where('sector', 'array-contains-any', sector).limit(100);
    //Search + date - pt. 1
    else if (search && !sector && startDate) firebaseQuery = db.collection('posts').where('date', '>=', startDate).orderBy('date', 'desc').limit(100);
    //Sectors + date
    else if (!search && sector && startDate) firebaseQuery = db.collection('posts').where('sector', 'array-contains-any', sector).where('date', '>=', startDate).orderBy('date', 'desc').limit(25);
    //Sectors + date + search - pt. 1
    else if (search && sector && startDate) firebaseQuery = db.collection('posts').where('sector', 'array-contains-any', sector).where('date', '>=', startDate).orderBy('date', 'desc').limit(100);
    
    if (!lastPost) {
      snapshot = await firebaseQuery.get();
      newLastPost = snapshot.docs[snapshot.docs.length-1];
    } else {
      snapshot = await firebaseQuery.startAfter(lastPost).get();
      newLastPost = snapshot.docs[snapshot.docs.length-1];
    }

    //Format data
    let fetchingData = [];
    snapshot.forEach((docRef) => {
      const newProm = new Promise((resolve) => {
        const doc = docRef.data();
        db.collection('posts').doc(docRef.id).collection('writable').doc('upvotes').get().then((upvoteSnap) => {
          const upvoteDoc = upvoteSnap.data();
          const row = formatPostsData(docRef.id, doc.authorName, doc.date.toDate(), doc.summary, doc.sector, doc.city, doc.region, doc.country, upvoteDoc.upvotes, doc.authorID, doc.description, doc.features, upvoteDoc.upvoters);
          postsData.push(row);
        }).then(() => resolve())
      });
      fetchingData.push(newProm);
    });
    await Promise.all(fetchingData)

    //Searching if search needed, or directly settting posts
    if (search) textSearch(setState, postsData, search, ["summary", "description", "city", "region", "country"], 0.23, existingPosts, setNoMore);
    else {
      if (lastPost && existingPosts) {
        if (postsData.length !== 0) setState([...existingPosts, ...postsData]);
        else setNoMore(true);
      }
      else setState(postsData);
    }
    if (setLoading) setLoading(false);

    setLastPost(newLastPost);
  }
  catch(error) {
    console.error(error.code, error.message);
    firebase.analytics().logEvent('search-error', {code: error.code, message: error.message});
  }    
}

export async function advancedSearch({setState, keywords, city, region, country, features, sector, startDate, endDate, authorName, upvotes, upvotesComparison, setLoading}) {
  try {
    upvotes = parseInt(upvotes, 10);
    setLoading(true);
    let specialUpvotesFilter = false; 
    let postsData = [];
    let featureSnapshot;
    let query = db.collection('posts');
    if (keywords && !city && !region && !country && features.length === 0 && sector.length === 0 && !startDate && !endDate && !authorName && !upvotes) query = db.collection('posts').where('date', '<', firebase.firestore.Timestamp.fromDate(new Date()));

    //Conditional where selectors
    if (city) query = query.where('city', '==', city);
    if (region) query = query.where('region', '==', region);
    if (country) query = query.where('country', '==', country);
    if (startDate) query = query.where('date', '>=', startDate);
    if (endDate) query = query.where('date', '<=', endDate);
    if (authorName) query = query.where('authorName', '==', authorName);
    if (features.length !== 0 && sector.length === 0) query = query.where('features', 'array-contains-any', features);
    else if (sector.length !== 0 && features.length === 0) query = query.where('sector', 'array-contains-any', sector);
    else if (sector.length !== 0 && features.length !== 0) {
      query = query.where('sector', 'array-contains-any', sector);
      featureSnapshot = await db.collection('posts').where('features', 'array-contains-any', features).get();
    }
    if (upvotes) {
      if (!startDate && !endDate) {
        if (upvotesComparison === 'Greater than') query = query.where('upvotes', '>', upvotes);
        else if (upvotesComparison === 'Less than') query = query.where('upvotes', '<', upvotes);
      } else specialUpvotesFilter = true;
    }

    //Get data and format
    let snapshot = await query.limit(250).get();
    let fetchingData = [];
    snapshot.forEach((docRef) => {
      const newProm = new Promise((resolve) => {
        const doc = docRef.data();
        db.collection('posts').doc(docRef.id).collection('writable').doc('upvotes').get().then((upvoteSnap) => {
          const upvoteDoc = upvoteSnap.data();
          const row = formatPostsData(docRef.id, doc.authorName, doc.date.toDate(), doc.summary, doc.sector, doc.city, doc.region, doc.country, upvoteDoc.upvotes, doc.authorID, doc.description, doc.features, upvoteDoc.upvoters);
          postsData.push(row);
        }).then(() => resolve())
      });
      fetchingData.push(newProm);
    });
    await Promise.all(fetchingData)

    //If we need to concatonate results from multiple array-contains-any
    if (featureSnapshot) {
      let featureResults = [];let finalResults = [];
      const existingIDs = postsData.map((post) => post.postID);
      featureSnapshot.forEach((docRef) => {
        const doc = docRef.data();
        db.collection('posts').doc(docRef.id).collection('writable').doc('upvotes').get().then((upvoteSnap) => {
          const upvoteDoc = upvoteSnap.data();
          const row = formatPostsData(docRef.id, doc.authorName, doc.date.toDate(), doc.summary, doc.sector, doc.city, doc.region, doc.country, upvoteDoc.upvotes, doc.authorID, doc.description, doc.features, upvoteDoc.upvoters);
          featureResults.push(row);
        })
      });
      //Logical AND. If the feature results post exists in the other query, THEN add it to results.
      featureResults.forEach((post) => {
        if (existingIDs.includes(post.postID)) finalResults.push(post);
      })
      postsData = finalResults;
    }

    //If special upvote filter
    if (specialUpvotesFilter) {
      if (upvotesComparison === 'Greater than') postsData = postsData.filter((post) => post.upvotes > upvotes);
      else if (upvotesComparison === 'Less than') postsData = postsData.filter((post) => post.upvotes < upvotes);
    }

    //Searching if search needed, or directly settting posts
    if (keywords) textSearch(setState, postsData, keywords, ["summary", "description"], 0.23);
    else setState(postsData);
    setLoading(false);

    //Analytics log
    let parameters = [];
    if (keywords) parameters.push('keywords');
    if (city) parameters.push('city');
    if (region) parameters.push('region');
    if (authorName) parameters.push('authorName');
    if (features.length !== 0) parameters.push('features');
    if (startDate) parameters.push('startDate');
    if (endDate) parameters.push('endDate');
    if (upvotes) parameters.push('upvotes');
    if (sector.length !== 0) parameters.push('sector');
    if (country[0]) parameters.push('country');
    firebase.analytics().logEvent('advanced-search-done', {parameters})
  } catch(error) {
    console.error(error.code, error.message);
    setLoading(false);
    firebase.analytics().logEvent('advanced-search-error', {code: error.code, message: error.message});
  }
}

function textSearch (setState, newData, search_text, _keys, _threshold, existingPosts, setNoMore, minMatch=3) {
  if(search_text !== undefined && search_text!=="" && newData.length !== 0){
    let options = {
      shouldSort: true,
      ignoreLocation: true,
      findAllMatches: true,
      threshold: _threshold,
      minMatchCharLength: minMatch,
      keys:_keys};

      let fuse = new Fuse(newData, options);
      newData = fuse.search(search_text);
      newData = newData.map( (res) => res.item);
  }
  if (!existingPosts) setState(newData);
  else {
    if (newData.length !== 0) setState([...existingPosts, ...newData]);
    else setNoMore(true);
  }
  return newData.length;
}

// =============== GET COMMENTS ====================

const formatCommentsData = (commentID, authorID, authorName, date, description, upvoters, upvotes, activity) => {
  return {commentID, authorID, authorName, date, description, upvoters, upvotes, activity};
}

export async function getComments({setState, postID, lastComment, setLastComment, existingComments, setNoMore}) {
  try {
    let comments = []; let snap = []; let newLastComment;
    let firebaseQuery = db.collection('posts').doc(postID).collection('postComments').limit(5);

    if (!lastComment) {
      snap = await firebaseQuery.get();
      newLastComment = snap.docs[snap.docs.length-1];
    } else {
      snap = await firebaseQuery.startAfter(lastComment).get();
      newLastComment = snap.docs[snap.docs.length-1];
    }

    //Get data + format
    let fetchingData = [];
    snap.forEach((docRef) => {
      const newProm = new Promise((resolve) => {
        const doc = docRef.data();
        db.collection('posts').doc(postID).collection('postComments').doc(docRef.id).collection('writable').doc('upvotes').get().then((upvoteSnap) => {
          const upvoteDoc = upvoteSnap.data();
          const comment = formatCommentsData(docRef.id, doc.authorID, doc.authorName, doc.date.toDate(), doc.description, upvoteDoc.upvoters, upvoteDoc.upvotes, doc.activity);
          comments.push(comment);
        }).then(() => resolve())
      });
      fetchingData.push(newProm);
    });
    await Promise.all(fetchingData)
    comments.sort((a, b) => (a.upvotes >= b.upvotes) ? -1 : 1);

    if (snap.docs.length > 0) {
      if (lastComment) setState([...existingComments, ...comments])
      else setState(comments);
      setLastComment(newLastComment);
    } else {
      if (lastComment) {
        setNoMore(true);
      }
      else setState([]);
    }
    if (lastComment) firebase.analytics().logEvent('comment_load');
  } catch(error) {
    console.error(error.code, error.message);
    firebase.analytics().logEvent('comment-load-error', {code: error.code, message: error.message});
  }
};

// ================ GET SPECIFIC POST =======================
export async function getSpecificPost({postID}) {
  try {
    const docRef = await db.collection('posts').doc(postID).get();
    const upvoteSnap = await db.collection('posts').doc(postID).collection('writable').doc('upvotes').get();
    const doc = docRef.data(); const upvoteDoc = upvoteSnap.data();
    let result = {}; 
    if (doc) result = formatPostsData(docRef.id, doc.authorName, doc.date.toDate(), doc.summary, doc.sector, doc.city, doc.region, doc.country, upvoteDoc.upvotes, doc.authorID, doc.description, doc.features, upvoteDoc.upvoters)
    return result;
  } catch(error) {console.error(error.code, error.message)};
}

// ============== GET AUTHOR DATA ================= 
export async function getAuthorData({authorID, existingUser, lastPost, setLastPost, setState, setLoading, setNoMore}) {
  try {
    let posts = []; let newLastPost;
    if (existingUser) {
      //Get and format data
      const postsSnapshot = await db.collection('posts').where('authorID', '==', authorID).orderBy('date', 'desc').limit(15).startAfter(lastPost).get();
      let fetchingData = [];
      postsSnapshot.forEach((docRef) => {
        const newProm = new Promise((resolve) => {
          const doc = docRef.data();
          db.collection('posts').doc(docRef.id).collection('writable').doc('upvotes').get().then((upvoteSnap) => {
            const upvoteDoc = upvoteSnap.data();
            const row = formatPostsData(docRef.id, doc.authorName, doc.date.toDate(), doc.summary, doc.sector, doc.city, doc.region, doc.country, upvoteDoc.upvotes, doc.authorID, doc.description, doc.features, upvoteDoc.upvoters);
            posts.push(row);
          }).then(() => resolve())
        });
        fetchingData.push(newProm);
      });
      await Promise.all(fetchingData)

      if (posts.length > 0) {
        const newPosts = [...existingUser.posts, ...posts];
        setState({...existingUser, posts: newPosts});
        newLastPost = postsSnapshot.docs[postsSnapshot.docs.length-1];
        setLastPost(newLastPost);
      }
      else setNoMore(true);
    } else {
      setLoading(true);
      const postsSnapshot = await db.collection('posts').where('authorID', '==', authorID).orderBy('date', 'desc').limit(10).get();
      const userRef = await db.collection('users').doc(authorID).get();
      const privateRef = await db.collection('users').doc(authorID).collection('private').doc('data').get();
      const user = userRef.data();
      const privateData = privateRef.data();
      Object.keys(privateData).forEach((k) => user[k] = privateData[k]);

      //Get posts data
      let fetchingData = [];
      postsSnapshot.forEach((docRef) => {
        const newProm = new Promise((resolve) => {
          const doc = docRef.data();
          db.collection('posts').doc(docRef.id).collection('writable').doc('upvotes').get().then((upvoteSnap) => {
            const upvoteDoc = upvoteSnap.data();
            const row = formatPostsData(docRef.id, doc.authorName, doc.date.toDate(), doc.summary, doc.sector, doc.city, doc.region, doc.country, upvoteDoc.upvotes, doc.authorID, doc.description, doc.features, upvoteDoc.upvoters);
            posts.push(row);
          }).then(() => resolve())
        });
        fetchingData.push(newProm);
      });
      await Promise.all(fetchingData)

      newLastPost = postsSnapshot.docs[postsSnapshot.docs.length-1];
      user.posts = posts;
      setState(user); setLastPost(newLastPost);
      setLoading(false);
    }

  } catch(error) {console.error(error.code, error.message)}
} 